import { FREE_CARRIAGE_CENTS } from "@/data/catalog";
import { useLang } from "@/i18n/LanguageContext";

export const money = (cents) =>
  document.documentElement.lang === "fr" ? `${(cents / 100).toFixed(2).replace(".", ",")} $` : `$${(cents / 100).toFixed(2)}`;

const Row = ({ label, value, testid, accent }) => (
  <div className="flex justify-between items-baseline gap-3">
    <span className={`text-[14px] ${accent ? "text-[#D2C08E]" : "text-[#E8DDC7]/85"}`}>{label}</span>
    <span data-testid={testid} className={`text-[15px] font-medium ${accent ? "text-[#D2C08E]" : "text-[#F3EEE3]"}`}>{value}</span>
  </div>
);

export const FreeShipBar = ({ totalCents, pricing }) => {
  const { t } = useLang();
  const progress = pricing.welcomeApplied ? 100 : Math.min(100, (totalCents / FREE_CARRIAGE_CENTS) * 100);
  return (
    <div data-testid="free-carriage-progress">
      <p className="text-[14px] text-[#E8DDC7] mb-2" data-testid="free-carriage-message" data-no-translate>
        {pricing.toFreeCents > 0
          ? t(`You're ${money(pricing.toFreeCents)} from free shipping.`, `Plus que ${money(pricing.toFreeCents)} avant la livraison gratuite.`)
          : t("Your order ships free.", "Votre commande est livrée gratuitement.")}
      </p>
      <div className="h-1.5 w-full rounded-full bg-[#E8DDC7]/15 overflow-hidden" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress)}>
        <div className="h-full bg-[#3F6B48] transition-[width] duration-500" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

export const CartTotals = ({ totalCents, pricing }) => {
  const { t } = useLang();
  const { packPct, discountCents, shippingCents, jarCount } = pricing;
  const nextPct = jarCount === 1 ? 10 : jarCount === 2 ? 15 : 0;
  return (
    <div className="space-y-2.5 mb-4" data-testid="cart-totals" data-no-translate>
      {nextPct > 0 && (
        <p data-testid="pack-nudge" className="text-[13px] text-[#D2C08E]">
          {t(`Add one more jar and save ${nextPct}% with multi-jar savings.`, `Ajoutez un pot et économisez ${nextPct} % avec les rabais multi-pots.`)}
        </p>
      )}
      <Row label={t("Subtotal", "Sous-total")} value={money(totalCents)} testid="cart-subtotal" />
      {packPct > 0 && <Row label={t(`Multi-jar savings · ${packPct}%`, `Rabais multi-pots · ${packPct} %`)} value={`−${money(discountCents)}`} testid="cart-pack-discount" accent />}
      {pricing.treatCents > 0 && <Row label={t("Birthday treat", "Gâterie d'anniversaire")} value={`−${money(pricing.treatCents)}`} testid="cart-treat-discount" accent />}
      <Row
        label={pricing.welcomeApplied ? t("Shipping · welcome gift", "Livraison · cadeau de bienvenue") : t("Shipping", "Livraison")}
        value={shippingCents ? t(`${money(shippingCents)} · free over $125`, `${money(shippingCents)} · gratuite dès 125 $`) : t("Free", "Gratuite")}
        testid="cart-shipping"
      />
    </div>
  );
};
